import { gql } from '@apollo/client';

export const getDetalleSucursalUbicom = gql`
query sucursalApi{
    detalleSucursalUbicom(ubicom:$ubicom)  
    @rest(type: "DetalleSucursalUbicom", path: "/gateway/sucursales/location/branch/{args.ubicom}"){
        id
        id_localidad   
        cod_ubic
        cod_centro
        suc_nombre
        tel_directo
        fax
        cod_postal
        horario
        domicilio
        entre_calles
        tel_interno
        latitud
        longitud
        desc_localidad
        caja_seguridad
    }
}
`   